import type { CSSObject } from '@emotion/react'
import { Color, Spacing } from '@opallabs/gem'
import type { StyleProps } from '../types'

export const container = ({ theme }: StyleProps): CSSObject => ({
  borderColor: Color[theme].Surface.N400,
  borderWidth: 0,
  borderStyle: 'solid',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  padding: Spacing.L,
  inlineSize: '100%',

  '& + &': {
    paddingBlockStart: 0,
  },
})
